export interface ResetPasswordRequest {
  newPassword: string;
}
